module.exports = __webpack_public_path__ + "img/zhongxin.e79a49fb.png";